export function customerCategoryMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      customerCategoryId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateCustomerCategoryId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}
export function fixGetManyCustomerCategorys(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      categoryId: resource.objectId,
    })),
  };
}

export function fixCreateCustomerCategoryId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function customerCategoryMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, customerCategoryId: json.result.objectId},
  };
}